import { default as axios } from "./axiosConfig";
import config, { axiosConfig } from "../config";

export interface EventPayload {
    isDelayed?: boolean;
    eventTypeKey: string;
    keyValue: string;
    params: { name: string; value: string | Date }[];
}
export async function sendEvent({ eventTypeKey, keyValue, params, isDelayed = false }: EventPayload): Promise<any> {
    const { status } = await axios.post(`${config.API_URL}/mtpl/event${isDelayed ? '?delay=true' : ''}`,
        {
            eventTypeKey,
            keyValue,
            params
        },
        axiosConfig
    );

    return status === 200;
}
